import { render, staticRenderFns } from "./InvoicePDF.vue?vue&type=template&id=4f13bcc5&"
import script from "./InvoicePDF.vue?vue&type=script&lang=js&"
export * from "./InvoicePDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports